// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"fb5c70ab","787":"6df47463"}[chunkId] + ".chunk.js";
};